export default "__VITE_ASSET__CDFm$wwe__"